import styled from "styled-components/macro";

export const Container = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1em;
  align-items: center;

  #logo {
    opacity: 0.5;
  }

  a.main-plugins-page-link {
    color: var(--grey-0);
  }

  .pluginTitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.5em;
    font-weight: 600;
    font-family: GT Super Text;

    svg {
      margin-right: 0.5em;
    }
  }
  ul {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style: none;
    opacity: 0.5;
    gap: 16px;
    align-items: center;
    li {
      margin: 0 0.5em;
      a {
        font-weight: 500;
        color: var(--grey-0);
        text-decoration: none;
      }
    }
  }
`;

export const CollapsedMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  button {
    color: var(--grey-0);
    justify-content: left;
  }
`;
